import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Docs = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">📚 Docs</h1>
          <p className="text-muted-foreground">company docs, tech stack guides, SOPs</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Docs Dashboard</CardTitle>
            <CardDescription>company docs, tech stack guides, SOPs</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Docs content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Docs;